import React from 'react'
import './TradeGridOverview.scss'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import tradegridLogoBlue from 'Assets/Images/Dashboard/general-overview/tradegrid-logo-blue.png'
import arrowUpGreen from 'Assets/Images/Dashboard/general-overview/arrow-up-green.svg'

type TxStatus = 'Pending' | 'Success'

const TradeGridOverview = () => {
  const { user } = useAuth()
  const name = user?.user?.name ?? 'Admin'

  const transactions: Array<{
    amount: string
    date: string
    product: string
    status: TxStatus
  }> = [
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Pending' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'TG plus', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Traderscard', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Boost', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'TG plus', status: 'Success' },
    { amount: '₦5,000,000', date: '08/05/2025', product: 'Traderscard', status: 'Success' },
  ]

  const usersList: Array<{ name: string; msisdn: string; acctType: string }> = [
    { name: 'James J', msisdn: '08123456789', acctType: 'Regular' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'TradersCard' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'TradersCard' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Regular' },
    { name: 'John Doe', msisdn: '08123456789', acctType: 'Regular' },
  ]

  return (
    <div className='tradegrid-overview-page'>
      <div className='container'>
        <div className='go-banner mb-4'>
          <div className='go-banner__content'>
            <div className='go-banner__welcome'>Welcome Back, {name}</div>
            <div className='go-banner__subtitle'>Here&apos;s your TradeGrid summary</div>
          </div>
        </div>

        <div className='tg-summary-card mb-4'>
          <img src={tradegridLogoBlue} className='tg-summary-card__logo' />
          <div className='tg-metrics'>
            <div className='tg-metric'>
              <div className='tg-metric__label'>Total Orders</div>
              <div className='tg-metric__value'>20,000</div>
              <div className='tg-metric__delta'>
                <img src={arrowUpGreen} className='tg-metric__delta-icon' />
                <span className='tg-metric__delta-up'>5%</span>
                <span className='tg-metric__delta-text'>+100 Orders</span>
              </div>
            </div>

            <div className='tg-metric'>
              <div className='tg-metric__label'>Total transaction</div>
              <div className='tg-metric__value'>1,500</div>
              <div className='tg-metric__delta'>
                <img src={arrowUpGreen} className='tg-metric__delta-icon' />
                <span className='tg-metric__delta-up'>5%</span>
                <span className='tg-metric__delta-text'>+100 new transactions</span>
              </div>
            </div>

            <div className='tg-metric'>
              <div className='tg-metric__label'>Total Users</div>
              <div className='tg-metric__value'>1,500</div>
              <div className='tg-metric__delta'>
                <img src={arrowUpGreen} className='tg-metric__delta-icon' />
                <span className='tg-metric__delta-up'>5%</span>
                <span className='tg-metric__delta-text'>+100 new users</span>
              </div>
            </div>

            <div className='tg-metric'>
              <div className='tg-metric__label'>Total Energy Supplied</div>
              <div className='tg-metric__value'>1,500</div>
              <div className='tg-metric__delta'>
                <img src={arrowUpGreen} className='tg-metric__delta-icon' />
                <span className='tg-metric__delta-up'>5%</span>
                <span className='tg-metric__delta-text'>+10 New Stations</span>
              </div>
            </div>

            <div className='tg-metric'>
              <div className='tg-metric__label'>Total Traderscard Orders</div>
              <div className='tg-metric__value'>1,500</div>
              <div className='tg-metric__delta'>
                <img src={arrowUpGreen} className='tg-metric__delta-icon' />
                <span className='tg-metric__delta-up'>5%</span>
                <span className='tg-metric__delta-text'>+100 Orders</span>
              </div>
            </div>
          </div>
        </div>

        <div className='row g-4 tg-bottom'>
          <div className='col-12 col-lg-7'>
            <div className='tg-section-title'>
              <div className='tg-section-title__left'>Recent Transactions</div>
              <div className='tg-section-title__right'>View all</div>
            </div>

            <div className='tg-table-card'>
              <div className='tg-table-card__head'>
                <div className='tg-table-card__col tg-table-card__col--amount'>Amount</div>
                <div className='tg-table-card__col tg-table-card__col--date'>Date</div>
                <div className='tg-table-card__col tg-table-card__col--product'>Product</div>
                <div className='tg-table-card__col tg-table-card__col--status'>Status</div>
              </div>

              <div className='tg-table-card__body'>
                {transactions.map((tx, idx) => (
                  <div
                    className={`tg-tx-row ${idx % 2 === 0 ? 'tg-tx-row--alt' : ''}`}
                    key={`${tx.product}-${idx}`}
                  >
                    <div className='tg-tx-row__col tg-tx-row__col--amount'>{tx.amount}</div>
                    <div className='tg-tx-row__col tg-tx-row__col--date'>{tx.date}</div>
                    <div className='tg-tx-row__col tg-tx-row__col--product'>{tx.product}</div>
                    <div className='tg-tx-row__col tg-tx-row__col--status'>
                      <div
                        className={`tg-status ${
                          tx.status === 'Pending' ? 'tg-status--pending' : 'tg-status--success'
                        }`}
                      >
                        {tx.status}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className='col-12 col-lg-5'>
            <div className='tg-users-card mb-4'>
              <div className='tg-users-card__header'>
                <div className='tg-users-card__title'>Recent Users</div>
                <div className='tg-users-card__action'>View all</div>
              </div>

              <div className='tg-users-card__table'>
                <div className='tg-users-card__row tg-users-card__row--head'>
                  <div className='tg-users-card__cell tg-users-card__cell--name'>Name</div>
                  <div className='tg-users-card__cell tg-users-card__cell--msisdn'>MSISDN</div>
                  <div className='tg-users-card__cell tg-users-card__cell--acct'>Acct.Type</div>
                </div>

                {usersList.map((u, idx) => (
                  <div className='tg-users-card__row' key={`${u.name}-${idx}`}>
                    <div className='tg-users-card__cell tg-users-card__cell--name'>{u.name}</div>
                    <div className='tg-users-card__cell tg-users-card__cell--msisdn'>
                      {u.msisdn}
                    </div>
                    <div className='tg-users-card__cell tg-users-card__cell--acct'>
                      {u.acctType}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className='tg-energy-card'>
              <div className='tg-energy-card__title'>Total Energy Supply</div>
              <div className='tg-energy-card__value'>2.0MKW</div>
              <div className='tg-energy-card__delta'>
                <img src={arrowUpGreen} className='tg-energy-card__delta-icon' />
                <span className='tg-energy-card__delta-up'>5%</span>
                <span className='tg-energy-card__delta-text'>+100 MW</span>
              </div>
            </div>
          </div>
        </div>

        <div className='tg-footer mt-4 mb-4'>© 2026 Tradegrid - All rights reserved.</div>
      </div>
    </div>
  )
}

export default TradeGridOverview

